import styled from '@emotion/styled'
import { Skeleton as AntdSkeleton } from 'antd'
import { FontColorProp } from './types'
import CommonButton from '@/components/common/Button'

export const InformationContainer = styled('div')<{ marginTop?: string; isEv?: boolean }>`
  display: grid;
  grid-template-columns: repeat(${(props) => (props.isEv ? 2 : 3)}, 1fr);
  margin-top: ${(props) => (props.marginTop ? props.marginTop : '32px')};
`

export const RightItemContainer = styled('div')`
  display: flex;
  flex-flow: wrap;
  justify-content: end;
`

export const Button = styled(CommonButton)<{ color: FontColorProp }>`
  display: flex;
  align-items: center;

  border: 1px solid #e5e5e5;
  box-sizing: border-box;

  color: ${(props) => props.color || '#000000'};
  margin-left: 8px;

  :hover {
    color: ${(props) => props.color || '#000000'};
    border-color: ${(props) => props.color || '#000000'};
  }

  :focus {
    color: ${(props) => props.color || '#000000'};
    border-color: ${(props) => props.color || '#000000'};
  }
`

export const Icon = styled('img')`
  margin-right: 9px;
`

export const Skeleton = styled(AntdSkeleton)`
  margin-top: 32px;
`

export const SkeletonButton = styled(AntdSkeleton.Button)`
  margin-left: 8px;
  width: 135px !important;
`

export const Info = styled('div')`
  font-size: 12px;
  color: #777777;
`

export const InfoTitle = styled('span')`
  color: #666666;
  font-size: 14px;
`

export const Title = styled('div')`
  font-size: 16px;
`

export const TitleBlock = styled('div')`
  margin-bottom: 16px;
`

export const ConfirmModalStyle = `
  .ant-modal-title {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    height: 50%;
  }

  .ant-btn-default {
    box-shadow: none;
    height: auto;
    padding: 10px 16px;
    border-radius: 8px;
  }

  .ant-modal-header {
    padding: 24px 24px 0px 24px;
    margin-bottom: 4px;
    border-bottom: unset;
  }

  .ant-modal-body {
    padding: 0px 24px 24px 24px;
  }

  .ant-modal-content {
    padding: 0px;
  }

  .ant-modal-footer {
    padding: 16px 24px;
    margin-top: 0px;
    background-color: #fafafa;
    border-radius: 0px 0px 11px 11px;
    border-top: unset;
  }
`

export const RegSimRemarkContainer = styled('div')`
  position: relative;
  width: 600px;
`

export const RegSimRemark = styled('div')`
  position: absolute;
  top: 6px;
  right: 0;
  font-size: 12px;
`

export const RegSimRemarkHeader = styled('span')`
  color: #f35c43;
  font-weight: 500;
`

export const RegSimRemarkContent = styled('span')`
  color: #f79282;
`
